import dayjs from "../../../utils/dayjs";
import { localStorageUserKey, roles } from "../../../utils/constants";
import { jwtDecode } from "jwt-decode";

export const initDateStartPrestation = () => {
  const token = localStorage.getItem(localStorageUserKey);
  if (token !== null) {
    var decoded = jwtDecode(token);
    if ([roles.admin, roles.permanance].includes(decoded?.role)) {
      return dayjs()
        .hour(13)
        .minute(0)
        .format();
    } else {
      // OTHER TOMORROW
      return dayjs()
        .add(1, "day")
        .hour(8)
        .minute(0)
        .format();
    }
  }
};

export const initDateEndPrestation = () => {
  const token = localStorage.getItem(localStorageUserKey);
  if (token !== null) {
    var decoded = jwtDecode(token);
    if ([roles.admin, roles.permanance].includes(decoded?.role)) {
      return dayjs()
        .hour(15)
        .minute(0)
        .format();
    } else {
      // OTHER TOMORROW
      return dayjs()
        .add(1, "day")
        .hour(10)
        .minute(0)
        .format();
    }
  }
};

export const initialStatePrestation = {
  prestation: {
    category: [],
    bill: null,
    isFollow: false,
    isSequentialPrestation: false,
    steps: {
      details: false,
      complements: false,
      searchInterpretes: false,
      resume: false,
      facturation: false,
    },
    name: "",
    selector: null,
    archived: false,
    interpretesStatus: [],
    intervention: {
      startDate: initDateStartPrestation(),
      endDate: initDateEndPrestation(),
      location: "",
      phone: "",
      linkVisio: "",
      extra: "",
      type: "",
      requestedBy: "",
    },
    billing: null,
    applicationAt: null,
    applicant: null,
    beneficiary: {
      reference: "",
      firstname: "",
      lastname: "",
    },
    interventionFinal: {
      endDate: null,
      finishAt: null,
      location: null,
      note: "",
      name: "",
      signing: "",
      phone: "",
      email: "",
      startDate: null,
    },

    intervenant: null,
    status: "draft",
    interprete: null,
    search: {
      searchQualification: ["licence", "certificate", "none"],
      searchLevel: ["expert", "intermediate", "standard"],
      searchGenre: ["female", "male"],
    },
    language: [],
    type: "",
    comment: {
      internal: "",
      interprete: "",
    },
    subject: "",
    reference: "",
    changes: {},
    institution: undefined,
    cancel: {
      cancelAt: null, // not accepted changes or cancel by admin
      cancelBy: null,
      cancelNote: "",
      applicantNotified: false,
      interpreteNotified: false,
    },
  },
  interpretes: [],
  deleteSuccess: false,
  cost: null,
  dangerousUpdate: false,
  ready: false,
  loading: false,
  loadingAppel: false,
  loadingEdit: false,
  interpretesHasSearch: false,
  loadingAnswer: false,
};
